<template>
  <div>
    <Evtable
      :header="fields"
      :showSearch="true"
      :quickSearchKey="quickSearch.quickSearchKey"
      :quickSearchReg="quickSearch.quickSearchReg"
      :quickSearchPlaceholder="quickSearch.quickSearchPlaceholder"
      :tools="tools"
      :actions="action"
      :searchData="searchdatas"
      :searchRules="searchRules"
      actionWidth="100"
      url="/bigdata-exchange/analysis/schedule/page"
      :pagination="true"
      :doPageload="pageload1"
      @select="select"
    >
      <template slot="searchForm">
        <el-col :span="12">
          <el-form-item label="清单名称" prop="search_LIKE_name">
            <el-input
              v-model="searchdatas.search_LIKE_name"
              placeholder="请输入清单名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数清单编码" prop="search_LIKE_scheduleCode">
            <el-input
              v-model="searchdatas.search_LIKE_scheduleCode"
              placeholder="请输入清单编码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业务名称" prop="search_LIKE_model">
            <el-input
              v-model="searchdatas.search_LIKE_model"
              placeholder="请输入业务名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </template>
    </Evtable>
  </div>
</template>

<script>
export default {
  data() {
    const that = this;
    return {
        selected: [],
      pageload1: false,
      search: "",
      searchRules: {},
      //搜索栏
      quickSearch: {
        quickSearchKey: "search_LIKE_name",
        quickSearchReg: /[%]|[_]|[*]/,
        quickSearchPlaceholder: "请输入清单名称"
      },

      // 工具栏
      tools: [
        {
          name: "analTaskConf:a", //添加
          click: function() {
            that.$router.push({
              name: "bigdata-exchange-analysis-scheduform",
              query: {
                id: -1
              }
            });
          }
        },
        {
          name: "analTaskConf:p", //批量删除
          text: "批量删除",
          click: function(a, refesh) {
            if (that.selected.length == 0) {
              that.$message({
                showClose: true,
                message: "请至少选择一项",
                type: "warning",
                duration: 2000
              });
            } else {
              that.bathdelete(that.selected, refesh);
            }
          }
        }
      ],
      // 列表数据
      fields: [
        {
          type: "check"
        },
        {
          label: "清单名称",
          align: "left",
          prop: "name"
        },
        {
          label: "清单编码",
          align: "left",
          prop: "scheduleCode",
          width: "200"
        },
        {
          label: "业务名称",
          align: "left",
          prop: "model",
          width: "150"
        },
        {
          label: "方法名称",
          align: "left",
          prop: "method",
          width: "230"
        },
        {
          label: "创建时间",
          align: "center",
          prop: "createDate",
          width: "180"
        }
      ],
      datas: [],
      action: [
        {
          name: "analTaskConf:u",
          icon: "fa-edit",
          click: function(e) {
            that.opt.editRow(e, that, "bigdata-exchange-analysis-scheduform", {
              id: e.scheduleId
            });
          }
        },
        {
          name: "analTaskConf:z",
          icon: "fas fa-arrow-alt-circle-right",
          click: function(e) {
            that.pageload1 = false;
            that.pageload1 = true;
            that.execute(e);
          }
        },
        {
          name: "analTaskConf:d",
          icon: "fa-trash-alt",
          click: function(row, refesh) {
            that.opt.deleteRow(
              row,
              refesh,
              "/bigdata-exchange/analysis/schedule/",
              that,
              "scheduleId"
            );
          }
        }
      ],
      searchfields: {
        row1: [
          {
            name: "search_LIKE_name",
            label: "清单名称",
            span: 12
          },
          {
            name: "search_LIKE_scheduleCode",
            label: "清单编码",
            span: 12
          }
        ],
        row2: [
          {
            name: "search_LIKE_model",
            label: "业务名称",
            span: 12
          }
        ]
      },
      searchdatas: {
          search_LIKE_name: "",
        search_LIKE_scheduleCode: "",
        search_LIKE_model: ""
      }
    };
  },
  methods: {
      select(e) {
          this.selected = e;
      },
    bathdelete: function(a, refesh) {
      let ids = [];
      for (let i = 0; i < a.length; i++) {
        let item = a[i];
        ids.push(item.scheduleId);
      }
      this.$confirm("确认要删除这些任务吗?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.request
            .deleteParam("/bigdata-exchange/analysis/schedule/batchDel", {
              ids: ids.join()
            })
            .then(res => {
              if (res.status === 1) {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                  refesh();
              } else if (res.status === 0) {
                this.$message.error(res.msg ? res.msg : "删除失败");
                  refesh();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    execute: function(e) {
      let id = e.scheduleId;
      this.$confirm("确定要执行该任务吗?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // this.pageload1 = true;
          this.request
            .get("/bigdata-exchange/analysis/schedule/execute/" + id + "", {})
            .then(res => {
              if (res.status === 1) {
                this.$message({
                  message: "执行成功",
                  type: "success"
                });
              } else if (res.status === 0) {
                this.$message.error(res.msg ? res.msg : "执行失败");
              }
              this.pageload1 = true;
              this.pageload1 = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消执行任务"
          });
          this.pageload1 = false;
        });
    }
  },
  created: function() {
    this.request.oprahfun(this);
  }
};
</script>



